(function($){
  $(document).ready(function(){

    function createCookie(name, value, days) {
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
      }
      else var expires = "";
      document.cookie = name + "=" + value + expires + "; path=/;domain=" + document.domain + "";
    }

    function processCookieLaw(cookieLawData) {
      if (isValueValid(cookieLawData)) { $('#cookiebar').hide(); } else { $('#cookiebar').show(); }
    }

    function getCookie(key) {
      var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
      return keyValue ? keyValue[2] : null;
    }





    $('.ourjouney_pic').click(function() {
      var $this = $(this);
      var dataGallery = $this.attr("data-gallery");
      var loader = $('.popUpJourneyMain[data-story="loading"]');
      var popUpOpen = $('.popUpJourneyMain[data-story="' + dataGallery + '"]');
      loader.show();
      setTimeout(function() {
        loader.hide();
      }, 2000);
      setTimeout(function() {
        popUpOpen.show().siblings().hide();
        //           	popUpOpen.addClass('open');
      }, 2001);


      console.log(loader.attr("data-story"));

      $first = $('.popUpJourneyMain').first();
      $last = $('.popUpJourneyMain').last();

      $curr = $(popUpOpen);
      $('.prev_arrow').click(function() {
        $curr = $curr.prev();
        // var loader = $('.popUpJourneyMain[data-story="loading"]');

        loader.show().siblings().hide();
        setTimeout(function() {
          loader.hide();
        }, 2000);
        setTimeout(function() {
          $curr.toggle().siblings().hide();
        }, 2001);


        $firstCurr = $curr.attr("data-story");
        $firstAttr = $first.attr("data-story");
        // if($firstCurr == $firstAttr) {

        // loader.show().siblings().hide();
        // setTimeout(function() {
        // loader.hide();
        // }, 2000);

        // setTimeout(function() {
        // $last.toggle().siblings().hide();
        // }, 2001);

        // 	$curr = $last;
        // }
      });


      $('#journeyBG').addClass('active');

      $('.next_arrow').click(function() {
        $curr = $curr.next();
        // var loader = $('.popUpJourneyMain[data-story="loading"]');

        loader.show().siblings().hide();
        setTimeout(function() {
          loader.hide();
        }, 2000);
        setTimeout(function() {
          $curr.toggle().siblings().hide();
        }, 2001);

        $lastCurr = $curr.attr("data-story");
        $lastAttr = $last.attr("data-story");
        // if($lastCurr == $lastAttr) {

        // 	loader.show().siblings().hide();
        // setTimeout(function() {
        // 	loader.hide();
        // }, 2000);
        // setTimeout(function() {
        //        $first.toggle().siblings().hide();
        //    }, 2001);
        // 	$curr = $first;
        // }	
      });

      console.log($first.attr("data-story"));


    });



    $('.popUpClose').click(function() {
      $('.popUpJourneyMain').hide();
      $('#journeyBG').removeClass('active');
    });
    $('#journeyBG').click(function(){
      $('.popUpJourneyMain').hide();
      $('#journeyBG').removeClass('active');      
    })


    //     new email scripts by Rengie
    $('#BR-email-signup-container .EmailRegistrationForm, .klaviyo-nexus').submit(function(e){
      //e.preventDefault();
      var $this = $(this),
          $input = $('#enter_emailFooter1input'),
          $input2 = $('#enter_emailFooter2input'),
          $inputPopup = $this.find('.popper-input'),
          //$mailForm = $('#mc-embedded-subscribe-form'),
          //$chimpInput = $mailForm.find('input[type=email]'),
          testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;

      const termsPrivacy = document.querySelector('[name="terms_privacy"]')

      if($this.hasClass('EmailRegistrationForm')){
        if($input.val() != $input2.val() || termsPrivacy.checked == false){
          e.preventDefault();
          $input.addClass('error');
          $input2.addClass('error');
        }
      }

      if(testEmail.test($input.val()) || testEmail.test($inputPopup.val()) || termsPrivacy.checked == false){
        //$chimpInput.val($input.val())
        //$('#mc-embedded-subscribe-form').submit();
        $input.removeClass('error');
        $input2.removeClass('error');
        $inputPopup.removeClass('error');
      } else {
        e.preventDefault();
        $input.addClass('error');
        $inputPopup.addClass('error');
      }

    })

    $('.popper-msj').click(function(e){
      var $this = $(this),
          $input = $this.siblings('.mail-input'),
          //$mailForm = $('#mc-embedded-subscribe-form'),
          //$chimpInput = $mailForm.find('input[type=email]'),
          testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;

      if($(window).width() > 768){
        if(testEmail.test($input.val())){
          //$chimpInput.val($input.val())
          //$('#mc-embedded-subscribe-form').submit();
          $input.removeClass('error')
        } else {
          e.preventDefault();
          $input.addClass('error')
        }
      }
    })

    //     previous BR email scripts by Rengie
    //     $('#BR-email-signup-container .EmailRegistrationForm').submit(function(e){
    //       e.preventDefault();
    //       	var $this = $(this),
    //         	$input = $('#enter_emailFooter1input'),
    //             $input2 = $('#enter_emailFooter2input'),
    //             $mailForm = $('#mc-embedded-subscribe-form'),
    //             $chimpInput = $mailForm.find('input[type=email]'),
    //             testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;

    //       if($input.val() != $input2.val()){
    //         e.preventDefault();
    //        	$input.addClass('error');
    //         $input2.addClass('error');
    //       } else if(!testEmail.test($input.val())){
    //          e.preventDefault;
    //          $input.addClass('error');
    //       }
    //       else {
    //         $chimpInput.val($input.val())
    //         $('#mc-embedded-subscribe-form').submit();
    //        	$input.removeClass('error');
    //         $input2.removeClass('error');
    //       }

    //     })

    //     $('.popper-msj').click(function(e){
    //       var $this = $(this),
    //           $input = $this.siblings('.mail-input'),
    //           $mailForm = $('#mc-embedded-subscribe-form'),
    //           $chimpInput = $mailForm.find('input[type=email]'),
    //           testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;

    //       if($(window).width() > 768){
    //         e.preventDefault();
    //       }

    //       if(testEmail.test($input.val())){
    //         $chimpInput.val($input.val())
    //         $('#mc-embedded-subscribe-form').submit();
    //         $input.removeClass('error')
    //       } else {
    //         $input.addClass('error')
    //       }

    //     })

    $('.address-edit-toggle').on('click', function(e) {
      e.preventDefault();
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });    

    $('#RecoverPassword').click(function(){

      $('#customer_login').slideToggle()
      $('#RecoverPasswordForm').slideToggle()
    })

    $('#HideRecoverPasswordLink').click(function(){

      $('#customer_login').slideToggle()
      $('#RecoverPasswordForm').slideToggle()
    })    


    //       //Popup appeartrigger
    //       if(window.location.href  == 'https://br-ph.myshopify.com/'){
    //         console.log('The url works')
    //         $('#popupload').fadeIn(500);
    //         $('#black-overlay4').fadeIn(500)
    //       }


    //Popup button functions
    $('#popup-close').click(function(){
      $('#popupload').fadeOut(500)
      $('#black-overlay4').fadeOut(500)
    })

    $('#black-overlay4').click(function(){ $('#popupload').fadeOut(500); $(this).fadeOut(500)})

    //       $('#bc-sf-filter-options-wrapper').append('<div style="display:none;" id="close-for-filter"><span class="one-line"></span><span class="two-line"></span></div>')   

    $('#bc-sf-filter-tree').delegate('#close-for-filter', 'click', function(e){
      $('#bc-sf-filter-tree').slideToggle(500)
      $('#black-overlay3').fadeOut(500)
    })



    var isFirstVisit = getCookie('firstvisit');    
    if (isFirstVisit == null ) {
      createCookie('firstvisit', '1', 1);
      setTimeout(function(){
        $('#popupload').fadeIn(500);
        $('#black-overlay4').fadeIn(500)
        $('#cookies-notice').fadeIn(500);
      },2000);
    } else {
      $('#popupload').hide();
      $('#black-overlay4').hide();
      $('#cookies-notice').hide();
    }    

    //Cookies close
    $('#cookies-notice .mkt_icon-close-svg, #cookies-notice .mkt_consent_button').click(function(){
      $(this).closest('#cookies-notice').fadeOut(500);
    })        

    $('#promo-drawer-mob .promodrawer-content .unique.details-btn').click(function(){
      var $this = $(this),
          countData = $this.data('count'),
          countSelector = "#modal-promo-banner" + countData;

      $(countSelector).fadeIn(500);
      $('#modal-black-overlay').fadeIn(500);

      //      	if($this.hasClass('first')){
      //      		$('#modal-promo-banner1').fadeIn(500);
      //      		$('#modal-black-overlay').fadeIn(500)

      //      	} else if($this.hasClass('second')){
      //      		$('#modal-promo-banner2').fadeIn(500);
      //      		$('#modal-black-overlay').fadeIn(500)

      //      	} else if($this.hasClass('third')){
      //      		$('#modal-promo-banner3').fadeIn(500);
      //      		$('#modal-black-overlay').fadeIn(500)

      //      	} else if($this.hasClass('fourth')){
      //      		$('#modal-promo-banner4').fadeIn(500);
      //      		$('#modal-black-overlay').fadeIn(500)

      //         } else if($this.hasClass('fifth')){
      //           $('#modal-promo-banner5').fadeIn(500);
      //           $('#modal-black-overlay').fadeIn(500)

      //         } else if($this.hasClass('sixth')){
      //           $('#modal-promo-banner6').fadeIn(500);
      //           $('#modal-black-overlay').fadeIn(500)

      //         }
    })

    $('#sale-banner .banner-details a').click(function(e){
      e.preventDefault();
      var $this = $(this),
          $lcount = $this.data("lcount"),
          $idCount = "#modal-sale-banner"+$lcount.toString();

      $($idCount).fadeIn(500);
      $('#modal-black-overlay').fadeIn(500)

      //      	$('#modal-promo-banner1').fadeIn(500);
      //       	$('#black-overlay5').fadeIn(500)
    })

    $('.unique-banner-modal .close-button, #modal-black-overlay, #video_close_inner').click(function(){
      var $this = $(this)


      $('.unique-banner-modal').fadeOut(500);
      $('#modal-black-overlay').fadeOut(500);
      $('.video-overlay').fadeOut(500);
      $('#video_close_inner').fadeOut(500);
      $('.video-overlay').find('video').remove();

    })

    //video js for GAP and BR
    $('.video-trigger-btn').click(function(){
      const iFrameDataActive = $("<video id='frameActive' class='pabs w-100p h-100p pt-0 pl-0' src='https://cdn.shopify.com/s/files/1/0063/4932/4335/files/Safety_Video1920x1080.mp4?v=1594105519' autobuffer='auto' preload controls></video>")

      $('.video-container').append(iFrameDataActive);
      document.getElementById('frameActive').play()

      $('.video-overlay').show();
      $('#modal-black-overlay').show();
      $('#video_close_inner').show();
    })   

    // $('#stick-popup .for-details').click(function(){
    //     $('#modal-promo-banner-popup').fadeIn(500)
    //     $('#modal-black-overlay').fadeIn(500)

    // })    


    $('.c-details-trig, .details-trigger').click(function(){
      $('#modal-promo-banner-popup').fadeIn(500)
      $('#modal-black-overlay').fadeIn(500)

    })

    $('#stick-popup .close-btn .span-container').click(function(){
      var $this = $(this);
      $this.closest('#stick-popup').fadeOut(500);
    })


    $('#modal-black-overlay').click(function(){
      var $this = $(this);

      $this.fadeOut(500)
      $('#modal-promo-banner1').fadeOut(500)
      $('#modal-promo-banner2').fadeOut(500)
      $('#modal-promo-banner3').fadeOut(500)
      $('#modal-promo-banner4').fadeOut(500)   
      $('#modal-promo-banner5').fadeOut(500)   
      $('#modal-promo-banner6').fadeOut(500)
      $('#modal-promo-banner-popup').fadeOut(500);
    })
    $('.modal-promo-banner-styles.promo-banner-modal1 .close-button').click(function(){
      var $this = $(this),
          modalParent = $this.closest('.modal-promo-banner-styles');

      modalParent.fadeOut(500)
      $('#modal-black-overlay').fadeOut(500)
    })    


    // handle links with @href started with '#' only
    $('#navbar-journey li a').click(function(e) {
      // target element id
      var $this = $(this);

      // target element
      var $id = $($this.attr('href'));
      if ($id.length === 0) {
        return;
      }

      // prevent standard hash navigation (avoid blinking in IE)
      e.preventDefault();

      // top position relative to the document
      var pos = $id.offset().top;

      // animated top scrolling
      $('body, html').animate({scrollTop: pos}, "1500");
    });

    // $(window).scroll(function(){
    //   //       console.log('Scroll works!');
    //   if($(document).scrollTop() > 900){
    //     $("#navbar-journey").sticky({topSpacing:0});
    //   } else {
    //     $("#navbar-journey").unstick();
    //   }

    // })

    $('.slider-trigger.slider-hero-banner').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 3000,
      autoplay: true,
      dots: true,
      arrows: false
    })

    $('.slider-trigger.slider-banner').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
      autoplay: true,
      autoplaySpeed: 5000,
      prevArrow: $('#sale-banner .promo-prev.saleprev'),
      nextArrow: $('#sale-banner .promo-next.salenext'),
      pauseOnHover: true,
      adaptiveHeight: true
    })


    $('.link-carousel .slide-trig').slick({
      slidesToShow: 2.5,
      slidesToScroll: 1,
      // speed: 3000,
      autoplay: false,
      initialSlide: 1,
      dots: true,
      prevArrow: $('.slide-prev.linkSlider-Arrow'),
      nextArrow: $('.slide-next.linkSlider-Arrow'),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 0
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            swipe: true,
            initialSlide: 0
          }
        }

      ]
    })    

    $('.slider-controls').click(function(){
      var $this = $(this)

      $this.toggleClass('unswitched')

      if($this.hasClass('play')){
        $this.prev().toggleClass('unswitched')
        $('.slider-trigger').slick('slickPlay');
      } else {
        $this.next().toggleClass('unswitched')
        $('.slider-trigger').slick('slickPause');
      }

    })


  })
})(jQuery)